"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var magnitudeCalc_1 = require("./calculations/magnitudeCalc");
var diameters_1 = require("./constants/diameters");
var Planet_1 = __importDefault(require("./Planet"));
var Mercury = (function (_super) {
    __extends(Mercury, _super);
    function Mercury(toi, useVsop87Short) {
        return _super.call(this, toi, 'mercury', useVsop87Short) || this;
    }
    Object.defineProperty(Mercury.prototype, "diameter", {
        get: function () {
            return diameters_1.DIAMETER_MERCURY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mercury.prototype, "vsop87J2000", {
        get: function () {
            return Promise.resolve().then(function () { return __importStar(require('./vsop87/vsop87MercurySphericalJ2000')); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mercury.prototype, "vsop87Date", {
        get: function () {
            return Promise.resolve().then(function () { return __importStar(require('./vsop87/vsop87MercurySphericalDate')); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mercury.prototype, "vsop87DateShort", {
        get: function () {
            return Promise.resolve().then(function () { return __importStar(require('./vsop87/vsop87MercurySphericalDateShort')); });
        },
        enumerable: false,
        configurable: true
    });
    Mercury.prototype.calculateApparentMagnitude = function (distanceSun, distanceEarth, phaseAngle) {
        return (0, magnitudeCalc_1.getApparentMagnitudeMercury)(distanceSun, distanceEarth, phaseAngle);
    };
    return Mercury;
}(Planet_1.default));
exports.default = Mercury;
